import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationCreateLongFormFromContentArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation CreateLongFormFromContent(
    $projectId: ID!
    $contentType: LongFormContentTypeEnum!
    $allInstructionsData: JSON!
    $imageResourceId: ID
    $inputSections: [ImproveSectionInput!]
  ) {
    createLongFormFromContent(
      projectId: $projectId
      contentType: $contentType
      allInstructionsData: $allInstructionsData
      imageResourceId: $imageResourceId
      inputSections: $inputSections
    ) {
      id
    }
  }
`;

type Variables = BackendMutationCreateLongFormFromContentArgs;
type Result = Pick<BackendJob, 'id'>;

export const createLongFormFromContent = async ({ allInstructionsData, ...rest }: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      allInstructionsData: stringifyIfPresent(allInstructionsData),
    },
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
